import { ModelBase } from "@shoothill/core";
import { observable, action } from "mobx";
import { IsNotEmpty, IsEmail, IsOptional, MaxLength } from "class-validator";

export interface ProjectDirectoryModelDTO {
    id: string | null;
    projectId: string;
    firstName: string;
    lastName: string;
    company: string;
    role: string;
    emailAddress: string;
    phoneNumber: string;
    isDeleted: boolean;
    rowVersion: string | undefined;
}

export class ProjectDirectoryModel extends ModelBase<ProjectDirectoryModel, ProjectDirectoryModelDTO> {
    @observable
    public id: string | null = null;

    @observable
    public projectId: string = "";

    @observable
    @IsNotEmpty({ message: "First name is required" })
    @MaxLength(255, { message: "First name cannot be longer than 255 characters" })
    public firstName: string = "";

    @observable
    @IsNotEmpty({ message: "Last name is required" })
    @MaxLength(255, { message: "Last name cannot be longer than 255 characters" })
    public lastName: string = "";

    @observable
    @MaxLength(255, { message: "Company name cannot be longer than 255 characters" })
    public company: string = "";

    @observable
    @MaxLength(255, { message: "Role cannot be longer than 255 characters" })
    public role: string = "";

    @observable
    @IsNotEmpty({ message: "Email address is required" })
    @IsEmail({}, { message: "Email address is invalid" })
    @MaxLength(255, { message: "Email address cannot be longer than 255 characters" })
    public emailAddress: string = "";

    @observable
    @MaxLength(255, { message: "Phone number cannot be longer than 255 characters" })
    public phoneNumber: string = "";

    @observable
    public createdByUserId: string | undefined = undefined;

    @observable
    public createdDate: string | undefined = undefined;

    @observable
    public lastUpdatedByUserId: string | undefined = undefined;

    @observable
    public lastUpdatedDate: string | undefined = undefined;

    @observable
    public isDeleted: boolean = false;

    @observable
    public rowVersion: string | undefined = undefined;

    @action
    public clear() {
        this.id = null;
        this.firstName = "";
        this.lastName = "";
        this.company = "";
        this.role = "";
        this.emailAddress = "";
        this.phoneNumber = "";
        this.createdByUserId = undefined;
        this.createdDate = undefined;
        this.lastUpdatedByUserId = undefined;
        this.lastUpdatedDate = undefined;
        this.isDeleted = false;
        this.rowVersion = undefined;
    }

    public fromDto(dto: ProjectDirectoryModelDTO): void {
        this.id = dto.id;
        this.firstName = dto.firstName;
        this.lastName = dto.lastName;
        this.company = dto.company;
        this.role = dto.role;
        this.emailAddress = dto.emailAddress;
        this.phoneNumber = dto.phoneNumber;
        this.projectId = dto.projectId;
        this.isDeleted = dto.isDeleted;
        this.rowVersion = dto.rowVersion;
    }

    public toDto(): ProjectDirectoryModelDTO {
        return {
            id: this.id,
            projectId: this.projectId,
            firstName: this.firstName,
            lastName: this.lastName,
            company: this.company,
            role: this.role,
            emailAddress: this.emailAddress,
            phoneNumber: this.phoneNumber,
            isDeleted: this.isDeleted,
            rowVersion: this.rowVersion,
        };
    }
}
